// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"DashboardHeader_pageTitle_HloJ5","level":"DashboardHeader_level_21is1","spinAround":"DashboardHeader_spinAround_1ysjJ"};